<template>
  <div class="order">
    <div class="order-header">
      <span style="position: absolute; left: 10px; top: 10px" @click="skip2"
        ><el-icon><ArrowLeftBold /></el-icon
      ></span>
      <div class="order-title">
        <span v-if="param.info.cus_name" style="font-size: 16px"
          >{{ param.info.cus_name }}-</span
        >出货条
      </div>
    </div>
    <div class="order-body">
      <div style="font-weight: 600">业务员：{{ param.info.wor_name }}</div>
      <div style="font-weight: 600">克重：{{ param.info.weight }}g</div>
      <div style="margin-top: 20px">
        <span style="font-weight: 600">扫描记录:</span>
        <div style="border: 1px solid #dcdfe6; margin-top: 5px; padding: 5px">
          <div
            style="display: flex; align-items: center; margin-bottom: 5px"
            v-for="(item, index) in param.list"
            :key="index"
          >
            <div style="width: 40%">{{ item.cus_name }}</div>
            <div style="width: 13%">{{ item.wor_name }}</div>
            <div style="width: 13%">{{ item.weight }}g</div>
            <div>{{ item.create_time }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { shipment_barcode_qr, shipment_scan_records } from "@/api/retention";
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const param = reactive({
  info: {},
  list: [],
});
const getInfos = async (barcode) => {
  const res = await shipment_barcode_qr({ barcode });
  if (res && res.status == 200 && res.data.code >= 1) {
    param.info = res.data.data;
  }
};
const getLists = async () => {
  const res = await shipment_scan_records();
  if (res && res.status == 200 && res.data.code >= 1) {
    param.list = res.data.data.data;
  }
};
const skip2 = () => {
  router.push({ path: `/index` });
};
onMounted(() => {
  // 监听函数
  window.globalFunction = (data2) => {
    // console.log(data, "外部函数被调用了！");
    getInfos(data2);
    getLists();
    // 你可以在这里做更多的事情
  };
});
</script>
<style scoped>
@import url("../assets/css/order.css");
.order {
  width: 100vw;
  height: 100vh;
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 5px 10px;
}
.order-title {
  margin: 0 auto;
  font-weight: 600;
  /* position: absolute;
  left: calc(50% - 32px); */
  font-size: 16px;
}
.order-body {
  padding: 10px;
}
</style>
